import _classCallCheck from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * A class which provides a reliable callback using either
 * a Web Worker, or if that isn't supported, falls back to setTimeout.
 */
export var Ticker = /*#__PURE__*/function () {
  function Ticker(callback, type, updateInterval) {
    _classCallCheck(this, Ticker);
    this._callback = callback;
    this._type = type;
    this._updateInterval = updateInterval;
    // create the clock source for the first time
    this._createClock();
  }
  /**
   * Generate a web worker
   */
  _createClass(Ticker, [{
    key: "_createWorker",
    value: function _createWorker() {
      var blob = new Blob([/* javascript */"\n\t\t\t// the initial timeout time\n\t\t\tlet timeoutTime =  ".concat((this._updateInterval * 1000).toFixed(1), ";\n\t\t\t// onmessage callback\n\t\t\tself.onmessage = function(msg){\n\t\t\t\ttimeoutTime = parseInt(msg.data);\n\t\t\t};\n\t\t\t// the tick function which posts a message\n\t\t\t// and schedules a new tick\n\t\t\tfunction tick(){\n\t\t\t\tsetTimeout(tick, timeoutTime);\n\t\t\t\tself.postMessage('tick');\n\t\t\t}\n\t\t\t// call tick initially\n\t\t\ttick();\n\t\t\t")], {
        type: "text/javascript"
      });
      var blobUrl = URL.createObjectURL(blob);
      var worker = new Worker(blobUrl);
      worker.onmessage = this._callback.bind(this);
      this._worker = worker;
    }
    /**
     * Create a timeout loop
     */
  }, {
    key: "_createTimeout",
    value: function _createTimeout() {
      var _this = this;
      this._timeout = setTimeout(function () {
        _this._createTimeout();
        _this._callback();
      }, this._updateInterval * 1000);
    }
    /**
     * Create the clock source.
     */
  }, {
    key: "_createClock",
    value: function _createClock() {
      if (this._type === "worker") {
        try {
          this._createWorker();
        } catch (e) {
          // workers not supported, fallback to timeout
          this._type = "timeout";
          this._createClock();
        }
      } else if (this._type === "timeout") {
        this._createTimeout();
      }
    }
    /**
     * Clean up the current clock source
     */
  }, {
    key: "_disposeClock",
    value: function _disposeClock() {
      if (this._timeout) {
        clearTimeout(this._timeout);
        this._timeout = 0;
      }
      if (this._worker) {
        this._worker.terminate();
        this._worker.onmessage = null;
      }
    }
    /**
     * The rate in seconds the ticker will update
     */
  }, {
    key: "updateInterval",
    get: function get() {
      return this._updateInterval;
    },
    set: function set(interval) {
      this._updateInterval = Math.max(interval, 128 / 44100);
      if (this._type === "worker") {
        this._worker.postMessage(Math.max(interval * 1000, 1));
      }
    }
    /**
     * The type of the ticker, either a worker or a timeout
     */
  }, {
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(type) {
      this._disposeClock();
      this._type = type;
      this._createClock();
    }
    /**
     * Clean up
     */
  }, {
    key: "dispose",
    value: function dispose() {
      this._disposeClock();
    }
  }]);
  return Ticker;
}();